<template>
  <view class="transfer-card" wx:if="{{trainInfo}}">
    <view class="transfer-card-header" wx:if="{{hasSelectedSeat}}">
      <view class="transfer-card-header-info">
        <view class="union-logotype">
          <image
            class="union-logotype-icon"
            src="https://ut-static.udache.com/webx/sfc/5jewOiQAoTmZ7i5nVfKvo.png"
          />
          <text>中转</text>
        </view>
        <view class="transfer-time-info">
          {{ transferTime }}
        </view>
      </view>
      <view class="transfer-card-header-toggle" bindtap="changeShowDetail">
        <text>{{ toggleText }}</text>
        <image
          class="icon"
          wx:class="{{showDetail && 'rotate'}}"
          src="https://ut-static.udache.com/webx/sfc/qjwThjrNdVx-Qd8e8pzmP.png"
        />
      </view>
    </view>
    <view class="transfer-card-content">
      <view class="expand-wrapper" wx:style="{{detailStyle}}">
        <view class="transfer-card-content-detail">
          <view wx:for="{{trainInfo.transfer_ticket}}">
            <train-information-new
              noDetail
              isTransfer
              cardIndex="{{index + 1}}"
              trainInfo="{{item}}"
              bind:click="showSSI"
            />
            <transfer-info-tip
              wx:if="{{index !== trainInfo.transfer_ticket.length - 1}}"
              wx:style="margin: 0 -12px"
              startStation="{{item?.to_station_name ?? ''}}"
              toStation="{{trainInfo?.transfer_ticket[index + 1]?.from_station_name ?? ''}}"
              stopTime="{{trainInfo.transfer_stop_time}}"
            />
          </view>
        </view>
      </view>
      <view class="expand-wrapper" wx:style="{{sketchyStyle}}">
        <view class="transfer-card-content-sketchy">
          <view class="transfer-card-content-sketchy-item" wx:for="{{trainInfo.transfer_ticket}}">
            <view class="left">
              <view class="placeholder">
                <view class="train-code">
                  {{ transferTrainInfo(item) }}
                </view>
              </view>
              <view class="station">
                <text>{{ item.from_station_name }}</text>
                <image
                  class="icon"
                  src="https://ut-static.udache.com/webx/sfc/X9HWVKNYaAb2Zu8ZlpcY4.png"
                />
                <text>{{ item.to_station_name }}</text>
              </view>
            </view>
            <view class="right">{{ getText(item, index) }}</view>
          </view>
        </view>
      </view>
    </view>
    <view class="selected-seat-info">{{ hasSelectedSeatPrice }}</view>
  </view>
</template>

<script>
    import { createComponent } from '@didi/es-mpx-creator'
    import dayjs from 'dayjs'
    import 'dayjs/locale/zh-cn'
    import store from '@/store'
    import { getFinalPrice } from '@/utils/money'
    dayjs.locale('zh-cn')

    createComponent({
      props: {
        trainInfo: {
          type: Object,
          value: () => {}
        },
        isExemption: {
          type: Boolean,
          value: false
        },
        hasRightsChoosed: {
          type: Boolean,
          value: false
        }
      },
      created() {
        this.showDetail = !!this.userGroup
      },
      data: {
        showDetail: false,
        expandStyle: {
          opacity: 1,
          'grid-template-rows': '1fr'
        },
        hideStyle: {
          opacity: 0,
          'grid-template-rows': '0fr'
        }
      },
      computed: {
        ...store.mapState({
          selectSeatInfo: 'train.selectSeatInfo',
          userGroup: 'common.userGroup',
          isTransfer: 'train.isTransfer'
        }),
        toggleText() {
          return this.showDetail ? '收起' : '详情'
        },
        transferTime() {
          // 为啥初始化不？会报错
          const day = dayjs(this.trainInfo?.start_time).format('M月D日')
          const arriveDay = dayjs(this.trainInfo?.arrive_time).format('M月D日')
          const week = dayjs(this.trainInfo?.start_time).format('周dd')
          const startHour = dayjs(this.trainInfo?.start_time).format('HH:mm')
          const arriveHour = dayjs(this.trainInfo?.arrive_time).format('HH:mm')
          const dayDifference = this.trainInfo?.day_difference ?? false
          return dayDifference
            ? `${day} ${startHour} - ${arriveDay} ${arriveHour}`
            : `${day} ${week} ${startHour}-${arriveHour}`
        },
        hasSelectedSeat() {
          return this.selectSeatInfo.every((item) => item && !!Object.keys(item).length)
        },
        detailStyle() {
          return this.showDetail ? this.expandStyle : this.hideStyle
        },
        sketchyStyle() {
          return this.showDetail ? this.hideStyle : this.expandStyle
        },
        hasSelectedSeatPrice() {
          return this.selectSeatInfo?.map((item,index)=>{
            return item && item?.seat_type_name ? 
              `${this.isTransfer ? `第${index+1}程 ` : ''}${item.seat_type_name} ¥${getFinalPrice(item.ticket_price)}` 
              : ''
          }).join("      ")
        }
      },
      methods: {
        changeShowDetail() {
          this.showDetail = !this.showDetail
        },
        getText(item, index) {
          const seatType = this.selectSeatInfo[index]?.seat_type_name ?? ''
          const _price = this.isExemption
            ? this.selectSeatInfo[index]?.highest_ticket_price
            : this.selectSeatInfo[index]?.ticket_price
          const prcie = getFinalPrice(_price ?? 0)
          const time = item?.travel_time_name ?? ''
          return this.userGroup ? `${time.substring(2, time.length)}` : `${seatType} ¥${prcie}`
        },
        transferTrainInfo(item) {
          const segment = item.union_segment_index
          const trainCode = item.train_code
          return `${segment}程 ${trainCode}`
        },
        showSSI(e) {
          this.triggerEvent('showSSI', e.detail ?? {})
        },
        hideDetail() {
          this.showDetail = false
        }
      }
    })
</script>

<style scoped lang="stylus">
  .transfer-card
    display flex
    flex-direction column
    background #fff
    margin 0 -12px
    padding 2px 16px 10px 16px
    &-header
      display flex
      justify-content space-between
      align-items center
      margin-bottom 12px
      &-info
        display flex
        align-items center
      .union-logotype
        padding 3px 6px
        border-radius 4px
        font-family PingFangSC-Medium
        font-size 12px
        font-weight 500
        line-height 12px
        text-align center
        color #FFFFFF
        background #FF6400
        margin-right 8px
        &-icon
          height 11px
          width 11px
          margin-right 2px
      .transfer-time-info
        font-family PingFangSC-Medium
        font-size 14px
        font-weight 500
        line-height 16px
        color #222
      &-toggle
        font-size 14px
        font-weight 400
        line-height 14px
        color #666
        display flex
        align-items center
        .icon
          height 4.5px
          width 8px
          margin-left 3px
          &.rotate
            transform rotate(180deg)
    &-content
      &-sketchy
        min-height 0
        overflow hidden
        display flex
        flex-direction column
        visibility visible
        opacity 1
        transition all 0.3s linear
        &-item
          display flex
          justify-content space-between
          align-items center
          &:not(:last-child)
            margin-bottom 10px
          .left
            display flex
            .placeholder
              min-width 71px
              margin-right 8px
              display flex
              .train-code
                padding 3px 6px
                font-family PingFangSC-Medium
                font-size 12px
                font-weight 500
                line-height 12px
                color #666
                border-radius 4px
                background #F2F6F9
            .station
              display flex
              align-items center
              font-family PingFangSC-Medium
              font-size 16px
              font-weight 500
              line-height 16px
              color #222
              .icon
                height 4px
                width 14px
                margin 0 4px
          .right
            font-size 13px
            font-weight 400
            line-height 13px
            color #666666
      &-detail
        min-height 0
        overflow hidden
  .expand-wrapper
    display grid
    transition grid-template-rows 0.5s 0s, opacity 0.5s 0.1s
    grid-template-columns 100%
    overflow hidden
  .selected-seat-info
    padding-left 14px
    margin-top 10px
    line-height 14px
    font-size 14px
    color #333
    font-family PingFangSC-Medium
    font-weight 500
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {
        'train-information-new': '@/components/train-information-new',
        'transfer-info-tip': '@/components/transfer-info-tip'
      }
    }
</script>